export const equipmentKinds = [
  ['television', 'Television'],
  ['streaming_player', 'Streaming player'], ['set_top_box', 'Set-top box'],
  ['gaming_console', 'Gaming console'], ['pc_media_player', 'PC / media player'],
  ['shared_feed', 'Shared feed'], ['soundbar', 'Soundbar'], ['av_receiver', 'AV receiver'],
  ['other', 'Other equipment'], ['unknown', 'Unknown'],
];

export function getEquipment(device) {
  let integration = device?.integration_data || device?.integrationData || {};
  if (typeof integration === 'string') {
    try { integration = JSON.parse(integration); } catch { integration = {}; }
  }
  return integration?.equipment || null;
}

export function isAudioEquipment(device) {
  return ['soundbar', 'av_receiver'].includes(getEquipment(device)?.kind);
}

export function isVideoConnection(connection, device) {
  return (!connection?.sourceRole || connection.sourceRole === 'video_source')
    && !connection?.isIgnored && !isAudioEquipment(device);
}
